// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from 'axios'

// import {Url} from '../../url/url'

// export const productdata =  createAsyncThunk('productdata', async ()=>{
//     const response = await axios.get(`${Url}/product`).then(data => data.data) 
//     console.log("response response productData", response);
    
//      return response 
//     //  return response.data 

//   })

// const ProductSlice = createSlice({
//     name: "product data",
//     initialState: { 
//         isLoading: false,
//         data: [],
//         totalCount : 0,
//         totalPages : 1,
//         currentPage : 1
//     },
//     extraReducers: (builder)=>{
//         builder.addCase(productdata.pending, (state,action)=>{
//           state.isLoading = true;
//         })
    
//       builder.addCase(productdata.fulfilled, (state,action)=>{
//         state.isLoading = false; 
//         state.data = action.payload.data; 
//         state.totalCount = action.payload.totalCount; 
//         state.totalPages = action.payload.totalPages; 
//         state.currentPage = action.payload.currentPage; 

//       });
//       builder.addCase(productdata.rejected, (state,action)=>{ 
//         state.isError=true;
//       })
//     }
// })
 
// export default ProductSlice.reducer;


 












import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';
import { Url } from '../../url/url';

export const productdata = createAsyncThunk('productdata', async () => {
  const response = await axios.get(`${Url}/product?limit=1000&page=1`);
  console.log("response response productData", response.data);
  return response.data; // ✅ sirf .data return karo (.then chain mat lagao)
});

const ProductSlice = createSlice({
  name: "product data",
  initialState: {
    isLoading: false,
    data: [],
    totalCount: 0,
    totalPages: 1,
    currentPage: 1
  },
  extraReducers: (builder) => {
    builder.addCase(productdata.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(productdata.fulfilled, (state, action) => {
      state.isLoading = false;

      // ✅ API response ke structure ke hisaab se handle karo
      // Case 1: agar response { data: [...], totalCount, totalPages } hai
      if (action.payload && action.payload.data) {
        state.data = action.payload.data;
        state.totalCount = action.payload.totalCount || 0;
        state.totalPages = action.payload.totalPages || 1;
        state.currentPage = action.payload.currentPage || 1;
      }
      // Case 2: agar response directly array hai [...] 
      else if (Array.isArray(action.payload)) {
        state.data = action.payload;
        state.totalCount = action.payload.length;
        state.totalPages = 1;
        state.currentPage = 1;
      }
    });

    builder.addCase(productdata.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });
  }
});

export default ProductSlice.reducer;